import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { border } from "@smartsheet/design-tokens";
import * as colors from "../../../constants/colors";
import { focusRingTheme } from "../../../util/createFocusRingStyles";
import { withFocusToggleClassName } from "../../../util/withFocusClassName";
import { SHOW_FOCUS_MARKER } from "../../focusMode/hooks/useFocusMode";
import { formInputTheme, getBackgroundColor, getBorderColor, getBorderWidth } from "../../textinput/styled/formInputTheme";

// These are used to derive the fact that a 4 line textarea with
// box-sizing: border-box is exactly 94px high, so we can avoid
// magic numbers.
export var VERTICAL_PADDING = 11;
export var LINE_HEIGHT_PX = 18;
export var SIZING_BUFFER = 1;
export var TextAreaStyled = withFocusToggleClassName(styled("textarea")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border-style: solid;\n    border-width: ", "px;\n    border-color: ", ";\n    border-radius: ", ";\n    background-color: ", ";\n\n    // If inline, this will include a bit of weird height at the bottom.\n    display: block;\n\n    padding: ", "px 12px ", "px;\n    width: 100%;\n    box-sizing: border-box;\n    transition: background-color 100ms ease-in-out;\n    resize: ", ";\n    color: ", ";\n\n    /* Font */\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: ", "px;\n    font-family: inherit;\n    &::placeholder {\n        color: ", ";\n    }\n\n    &:hover::placeholder {\n        color: ", ";\n    }\n\n    // Some high-contrast modes turn off box-shadows. In that case, we'll want to allow those HC\n    // stylesheets to provide their own outline colors rather than turning off outlines entirely.\n    outline: 3px solid transparent;\n    body.", " &:focus {\n        ", "\n    }\n"])), getBorderWidth, getBorderColor, function (_ref) {
  var themeMode = _ref.themeMode;
  return formInputTheme.borderRadius(themeMode);
}, getBackgroundColor, VERTICAL_PADDING, VERTICAL_PADDING - SIZING_BUFFER, function (props) {
  return props.disableManualResize ? "none" : "vertical";
}, colors.neutralDark40, function (_ref2) {
  var themeMode = _ref2.themeMode;
  return formInputTheme.fontSize.box(themeMode);
}, function (_ref3) {
  var themeMode = _ref3.themeMode;
  return formInputTheme.fontWeight(themeMode);
}, LINE_HEIGHT_PX, function (_ref4) {
  var themeMode = _ref4.themeMode;
  return formInputTheme.placeholderColor.rest(themeMode);
}, function (_ref5) {
  var themeMode = _ref5.themeMode;
  return formInputTheme.placeholderColor.hover(themeMode);
}, SHOW_FOCUS_MARKER, getFocusStyles));
function getFocusStyles(_ref6) {
  var themeMode = _ref6.themeMode,
    validationState = _ref6.validationState;
  // Normally we'd use createFocusRingStyles here but we can't do that here since
  // you cannot use a ::before element in a textarea.
  switch (themeMode) {
    case "ursa-light":
      return "\n                box-shadow:\n                    0 0 0 ".concat(border.width10, " ").concat(focusRingTheme.innerColor(themeMode), ",\n                    0 0 0 calc(1px + ").concat(border.width20, ") ").concat(focusRingTheme.outerColor(themeMode), "\n                ;\n            ");
    default:
      return "\n                border-color: ".concat(validationState === "error" ? formInputTheme.borderColor.error(themeMode) : formInputTheme.borderColor.focus(themeMode), ";\n            ");
  }
}
//# sourceMappingURL=TextAreaStyled.js.map